import { createFileRoute, Outlet } from "@tanstack/react-router"

export const Route = createFileRoute("/app/duties/absences")({
  component: Outlet,
  beforeLoad: ({ context: { t } }) => ({
    getTitle: () => t("Absences"),
  }),
})
